/**
 * React Query cache keys
 * Centralized enum to avoid typos and ensure consistency
 */
export enum QueryKey {
  PUBLIC_SURVEY = 'public-survey',
  PUBLIC_TEAM_HEALTH_METRICS = 'public-team-health-metrics',
  ACTION_PLAN_FOCUS = 'action-plan-focus',
  ACTION_PLAN_TEMPLATE = 'action-plan-template',
  ACTION_PLAN_AGGREGATED = 'action-plan-aggregated',
}
